import type { ReactNode } from "react";
import { useOutletContext } from "react-router-dom";
import type { Caps } from "../../../lib/tournamentPhases";
import { EmptyState } from "../../../components/ui";
import type { TournamentContext } from "./TournamentShell";

/**
 * A phase route outside the caller's grant (console spec §3.1). The rail never
 * links to one, so this only meets a bookmark or a link that outlived
 * someone's access — and it says whose page it is, since every phase past
 * Scores belongs to the event's organizers rather than to the organization.
 */
export function RequireCap({ cap, children }: { cap: keyof Caps; children: ReactNode }) {
  const { caps } = useOutletContext<TournamentContext>();
  if (!caps[cap])
    return (
      <EmptyState
        title="That page is for this tournament’s organizers"
        hint="Everything you can do here is on the Overview."
        className="mx-auto max-w-md"
      />
    );
  return <>{children}</>;
}
